import { useEffect, useState } from "react";
import CarTypesService from "../services/car_types_service";
import firebase from 'firebase/app';
import 'firebase/firestore';

interface props {
    typeId?: string,
    onChange(typeId: string): void,
}
const CarTypeSelector : React.FC<props> = ({ typeId, onChange })=> {
    const [isLoading, setLoading] = useState(true);
    const [results, setResults] = useState<firebase.firestore.QueryDocumentSnapshot[]>([]);

    useEffect(()=> {
        new CarTypesService().getTypes().then( types => {
            setLoading(false);
            setResults(types.docs);
        })
    }, []);

    const handleChange = (id: string)=> {
        onChange(id);
    }



    if(isLoading){
        return (<></>);
    }

    return (
        <select className="input select" name="default" onChange={(e)=> handleChange(e.target.value)}>
            {
                results.map(element => {
                    const doc = element.data();
                    console.log(typeId);
                    
                    

                    return <option value={element.id} selected={element.id === typeId} key={Math.random()}>
                        {doc.name}
                    </option>
                })
            }
        </select>
    );
}

export default CarTypeSelector;